import axios from "../lib/axios";

export const fetchChains = (params = {}) => {
  const url = `/chains`;

  return axios
    .get(url, {
      params: params,
    })
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};
